module.exports = __webpack_public_path__ + "media/brands/gm-daewoo-326993cb.png";